import AlertsReducer from 'store/alerts/reducer';

export { default as alertsTypes } from 'store/alerts/types';
export { default as alertsSaga } from 'store/alerts/saga';
export { default as alertsSelectors } from 'store/alerts/selectors';

export default AlertsReducer;
